import { render, staticRenderFns } from "./orderListShow.vue?vue&type=template&id=4e2041d5&scoped=true"
import script from "./orderListShow.vue?vue&type=script&lang=js"
export * from "./orderListShow.vue?vue&type=script&lang=js"
import style0 from "./orderListShow.vue?vue&type=style&index=0&id=4e2041d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2041d5",
  null
  
)

export default component.exports